import i18n from './i18n';
import { I18nextProvider  } from 'react-i18next';
const t = i18n.t;

export { 
    i18n,
    t,
    // withNamespaces,
    I18nextProvider
}